export default __webpack_public_path__ + "static/media/people.bec8a16e.svg";